import { render, staticRenderFns } from "./RelativeLoading.vue?vue&type=template&id=c088c0c2&scoped=true&lang=pug"
import script from "./RelativeLoading.vue?vue&type=script&lang=ts"
export * from "./RelativeLoading.vue?vue&type=script&lang=ts"
import style0 from "./RelativeLoading.vue?vue&type=style&index=0&id=c088c0c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c088c0c2",
  null
  
)

export default component.exports